import { axiosPrivate } from '../axiosClient';
import { recordReceiptPrint } from '../api/orders';
import { canEmployeeIssueReceipt } from '../utils/roles';

/**
 * Tells the server who printed or shared an order's receipt, so a payment
 * that lands later with no one at the till reaches them. Fire and forget: a
 * failed or offline report is not retried and never holds up the receipt.
 */
export function reportReceiptIssued(
  orderId: unknown,
  role: string | null | undefined,
): void {
  const id = String(orderId ?? '').trim();
  if (!id || !canEmployeeIssueReceipt(role)) return;
  recordReceiptPrint(axiosPrivate, id).catch(() => undefined);
}
